import NumberSupport from 'sharedreact/utils/NumberSupport';
import UnitSupport from 'sharedreact/utils/UnitSupport';

function isUnitValue (valueString: string, displayUnit: string, internalUnit: string): boolean {
  return UnitSupport.isValidUnitString(valueString, displayUnit, internalUnit);
}

function isUnitGreaterThanOrEqualTo (valueString: string, displayUnit: string, internalUnit: string, greaterThanOrEqualTo: number, precision: number = NumberSupport.defaultPrecision): boolean {
  const value: number | null = UnitSupport.unitStringToNumber(valueString, displayUnit, internalUnit, precision);

  if (value != null) {
    return NumberSupport.isGreaterThanOrEqualTo(value, greaterThanOrEqualTo, precision);
  }

  return false;
}

function isUnitGreaterThan (valueString: string, displayUnit: string, internalUnit: string, greaterThan: number, precision: number = NumberSupport.defaultPrecision): boolean {
  const value: number | null = UnitSupport.unitStringToNumber(valueString, displayUnit, internalUnit, precision);

  if (value != null) {
    return NumberSupport.isGreaterThan(value, greaterThan, precision);
  }

  return false;
}

function isUnitLessThanOrEqualTo (valueString: string, displayUnit: string, internalUnit: string, lessThanOrEqualTo: number, precision: number = NumberSupport.defaultPrecision): boolean {
  const value: number | null = UnitSupport.unitStringToNumber(valueString, displayUnit, internalUnit, precision);

  if (value != null) {
    return NumberSupport.isLessThanOrEqualTo(value, lessThanOrEqualTo, precision);
  }

  return false;
}

function isUnitLessThan (valueString: string, displayUnit: string, internalUnit: string, lessThan: number, precision: number = NumberSupport.defaultPrecision): boolean {
  const value: number | null = UnitSupport.unitStringToNumber(valueString, displayUnit, internalUnit, precision);

  if (value != null) {
    return NumberSupport.isLessThan(value, lessThan, precision);
  }

  return false;
}

const UnitValidators = {
  isUnitValue,
  isUnitGreaterThanOrEqualTo,
  isUnitGreaterThan,
  isUnitLessThanOrEqualTo,
  isUnitLessThan
};

export {
  isUnitValue,
  isUnitGreaterThanOrEqualTo,
  isUnitGreaterThan,
  isUnitLessThanOrEqualTo,
  isUnitLessThan
};

export default UnitValidators;
